import { Field, useFormikContext } from "formik";
import React from "react";
import { useIntl } from "react-intl";

const DropDownInput = ({
  fieldName,
  options,
  placeholder,
  dependant,
  id,
  onChange,
  enabledOptions,
  translate = true
}) => {
  const { values, setFieldValue } = useFormikContext();
  const intl = useIntl();

  const value = dependant ? values[dependant] : null;
  React.useEffect(() => {
    if (dependant) {
      setFieldValue(fieldName, "");
    }
  }, [value, fieldName, setFieldValue, dependant]);

  return (
    <Field name={fieldName} id={fieldName}>
      {({ field: { value }, form: { handleChange } }) => (
        <div className="h-full">
          <select
            name={fieldName}
            id={id}
            className="absolute top-0 bottom-0 left-0 right-0 rounded-none appearance-none border-b border-white w-full focus:outline-none focus:shadow-outline opacity-0 text-gray-900"
            onChange={e => {
              handleChange(e);
              onChange && onChange();
            }}
            value={value}
          >
            {placeholder && <option value={""}>{placeholder}</option>}
            {options &&
              Object.keys(options).map((k, i) => {
                return (
                  <option
                    key={k}
                    value={k}
                    disabled={
                      enabledOptions ? !enabledOptions.includes(k) : false
                    }
                  >
                    {translate
                      ? intl.formatMessage({ id: options[k] })
                      : options[k]}
                  </option>
                );
              })}
          </select>
          <p className="rounded-none flex items-center appearance-none border-b border-primary h-full w-full p-1 text-input leading-tight focus:outline-none focus:shadow-outline">
            {value ? (
              translate ? (
                options[value] && intl.formatMessage({ id: options[value] })
              ) : (
                options[value]
              )
            ) : (
              <span>{placeholder}</span>
            )}
          </p>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 text-black">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path
                fill="none"
                fillRule="evenodd"
                stroke="#000000E5"
                d="M3 6L9 12 15 6"
              />
            </svg>
          </div>
        </div>
      )}
    </Field>
  );
};

export default DropDownInput;
